import { useTranslation } from 'react-i18next';



interface ErrorElementProps {
	size?: number
}


const ErrorElement = (props: ErrorElementProps) => {
	const { size = 1.2 } = props;
	const { t } = useTranslation('global');

	return (
		<div className="lfmt-error error-element" style={{ fontSize: `${size}rem`}}>
			
			<p>{t('errorMessage')}</p>

		</div>
	);
};

export default ErrorElement;